import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, chakra } from '@chakra-ui/react';
import styled from 'styled-components';

import Logo from '@repo/ui-components/dept/atoms/Logo';
import NavCartButton from '@repo/ui-components/dept/atoms/NavCartButton';
import SearchInput from '@repo/ui-components/dept/atoms/SearchInput';
import DesktopNav from '@repo/ui-components/dept/molecules/DesktopNav';
import Link from '@repo/ui-components/tailwind/Link';
import { NonCommerceInfoContext } from '@repo/contexts';
import NavAccountButton from '../../atoms/NavAccountButton';

const StyledNavbar = styled(Flex)`
  // Firefox
  scrollbar-width: thin;
  scrollbar-color: #e2e5e9 transparent;

  // Chrome and Safari
  *::-webkit-scrollbar {
    width: 0.25rem;

    &-track {
      background: transparent;
    }

    &-thumb {
      background: #e2e5e9;
      border-radius: 0.25rem;
    }
  }
`;

function NavBar({ menuItems, atTopOfPage, bannerShowing }) {
  const { isNonCommerce } = useContext(NonCommerceInfoContext);

  const topBorderRadius = atTopOfPage ? 'lg' : 0;

  return (
    <StyledNavbar
      pos="relative"
      bg="brand.ink"
      borderTopLeftRadius={{ xl: topBorderRadius }}
      borderTopRightRadius={{ xl: topBorderRadius }}
      borderBottomRightRadius={{ xl: 'lg' }}
      borderBottomLeftRadius={{ xl: 'lg' }}
      mx={{ xl: '6' }}
      direction="column"
    >
      <Flex
        align="center"
        gap={0}
        px={{ base: '4', lg: '6' }}
        mx="auto"
        maxW="1680px"
        justifyContent="space-between"
        w="100%"
      >
        <Flex align="center">
          <chakra.div as={isNonCommerce ? 'div' : Link} link="/">
            <Logo yellow width={{ base: '140px', sm: '150px' }} />
          </chakra.div>

          {!isNonCommerce && (
            <DesktopNav
              display={{ base: 'none', lg: 'flex' }}
              menuItems={menuItems}
              atTopOfPage={atTopOfPage}
              mr="auto"
              bannerShowing={bannerShowing}
            />
          )}
        </Flex>

        <Box>
          <Flex
            gap={1}
            align="center"
            p="0"
            h="5rem"
            ml="auto"
            justify="flex-end"
          >
            {!isNonCommerce && (
              <>
                <SearchInput display={{ base: 'none', lg: 'block' }} />

                <NavCartButton />

                <NavAccountButton />
              </>
            )}
          </Flex>
        </Box>
      </Flex>
    </StyledNavbar>
  );
}

NavBar.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      menuType: PropTypes.string,
      _key: PropTypes.string,
    })
  ).isRequired,
  atTopOfPage: PropTypes.bool.isRequired,
  bannerShowing: PropTypes.bool.isRequired,
};

export default NavBar;
